export default __webpack_public_path__ + "static/media/art7.e5bdb2c2.jpeg";